export const FACTURACION_ABOGADOS_MODULE_NAME = "facturacion_abogados_module";

export const facturacionAbogadosModuleMenuItem = {
  icon: "file-invoice-dollar",
  path: "/facturacion-abogados",
};

export const facturacionAbogadosModuleRoutes = [
  {
    path: "facturacion-abogados",
    name: "FacturacionAbogadosServicios",
    redirect: "/dynamic-model/Servicio",
    meta: {
      title: "Facturacion de abogados",
      requiresAuth: true,
      requiresModule: FACTURACION_ABOGADOS_MODULE_NAME,
    },
  },
];

export default {
  moduleName: FACTURACION_ABOGADOS_MODULE_NAME,
  routes: facturacionAbogadosModuleRoutes,
  menuItem: facturacionAbogadosModuleMenuItem,
};
